import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = ({ isActive, ...rest }) => {
  return isActive ? (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M8.89844 20.3779C6.54141 20.3779 5.3629 20.3779 4.63067 19.6457C3.89844 18.9135 3.89844 17.735 3.89844 15.3779V10.3779C3.89844 8.02091 3.89844 6.8424 4.63067 6.11016C5.3629 5.37793 6.54141 5.37793 8.89844 5.37793"
        stroke="#F59C53"
        strokeWidth="1.5"
      />
      <path
        d="M8.90039 7.87793C8.9125 5.7029 9.00895 4.52499 9.77733 3.75661C10.656 2.87793 12.0702 2.87793 14.8987 2.87793H15.8987C18.7271 2.87793 20.1413 2.87793 21.02 3.75661C21.8987 4.63529 21.8987 6.0495 21.8987 8.87793V16.8779C21.8987 19.7064 21.8987 21.1206 21.02 21.9993C20.1413 22.8779 18.7271 22.8779 15.8987 22.8779H14.8987C12.0702 22.8779 10.656 22.8779 9.77733 21.9993C9.00895 21.2309 8.9125 20.053 8.90039 17.8779"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.8984 12.8779L6.89844 12.8779M6.89844 12.8779L8.89844 14.8779M6.89844 12.8779L8.89844 10.8779"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M8.87744 19.623C6.52042 19.623 5.34191 19.623 4.60967 18.8908C3.87744 18.1586 3.87744 16.9801 3.87744 14.623V9.62305C3.87744 7.26602 3.87744 6.08751 4.60967 5.35528C5.34191 4.62305 6.52042 4.62305 8.87744 4.62305"
        stroke="white"
        strokeOpacity="0.5"
        strokeWidth="1.5"
      />
      <path
        d="M8.87988 7.12305C8.89199 4.94802 8.98844 3.77011 9.75682 3.00173C10.6355 2.12305 12.0497 2.12305 14.8781 2.12305H15.8781C18.7066 2.12305 20.1208 2.12305 20.9995 3.00173C21.8781 3.88041 21.8781 5.29462 21.8781 8.12305V16.123C21.8781 18.9515 21.8781 20.3657 20.9995 21.2444C20.1208 22.123 18.7066 22.123 15.8781 22.123H14.8781C12.0497 22.123 10.6355 22.123 9.75682 21.2444C8.98844 20.476 8.89199 19.2981 8.87988 17.123"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.8774 12.123L6.87744 12.123M6.87744 12.123L8.87744 14.123M6.87744 12.123L8.87744 10.123"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Icon;
